'use client'

import React from 'react';
import s from './page.module.scss';
import {Container} from "@/app/[locale]/common/components/Container/Container";
import {Breadcrumbs} from "@/app/[locale]/common/components/Breadcrumbs/Breadcrumbs";
import {Title} from "@/app/[locale]/common/components/Title/Title";
import main from '../../common/assets/images/industires/diesel-generators/main.webp';
import Image from "next/image";
import {ContactUs} from "@/app/[locale]/common/components/ContactUs/ContactUs";
import monitoring_equipment from '../../common/assets/images/industires/diesel-generators/monitoring-equipment.webp';
import online_control from '../../common/assets/images/industires/diesel-generators/online_control.webp';
import {ConfirmIcon} from "@/app/[locale]/common/assets/ConfirmIcon/ConfirmIcon";
import {ParagraphLine} from "@/app/[locale]/common/components/ParagraphLine/ParagraphLine";
import generator_sets from '../../common/assets/images/industires/diesel-generators/generator-sets.webp';
import {TTasksCardContent, TUserCardContent} from "@/app/[locale]/industries/types";
import {ELEMENT_INDEX} from "../../common/constants/app";
import {TaskCard} from "@/app/[locale]/common/components/TaskCard/TaskCard";
import {SliderBlock} from "@/app/[locale]/common/components/SliderBlock/SliderBlock";
import {TDieselGeneratorSlideCardProps} from "@/app/[locale]/common/components/DieselGeneratorSlideCard/types";
import {DieselGeneratorSlideCard} from "@/app/[locale]/common/components/DieselGeneratorSlideCard/DieselGeneratorSlideCard";
import {useTranslations} from "next-intl";
import {
    addDataToTranslatedArray
} from "@/app/[locale]/common/utils/functions/addDataToTranslatedArray/addDataToTranslatedArray";
import {DataMonitoringIcon} from "@/app/[locale]/common/assets/DataMonitoringIcon/DataMonitoringIcon";
import {EngineIcon} from "@/app/[locale]/common/assets/EngineIcon/EngineIcon";
import {RemoteManagementIcon} from "@/app/[locale]/common/assets/RemoteManagementIcon/RemoteManagementIcon";
import {FuelIcon} from "@/app/[locale]/common/assets/FuelIcon/FuelIcon";
import slide1 from "@/app/[locale]/common/assets/images/industires/diesel-generators/slider/slide-1.webp";
import slide2 from "@/app/[locale]/common/assets/images/industires/diesel-generators/slider/slide-2.webp";
import slide3 from "@/app/[locale]/common/assets/images/industires/diesel-generators/slider/slide-3.webp";
import {TIndustriesCardProps} from "@/app/[locale]/common/components/Industries/types";

export default function DieselGenerators() {
    const t = useTranslations('DieselGeneratorsPage');

    const tasksCards: TTasksCardContent[] = addDataToTranslatedArray(t.raw('tasksBlock.cardsData'), [DataMonitoringIcon, EngineIcon, RemoteManagementIcon, FuelIcon], 'Icon');
    const casesCards: TIndustriesCardProps[] = addDataToTranslatedArray(t.raw('cases.cardsData'), [slide1, slide2, slide3], 'image');

    return (
        <div className={s.diesel}>
            <Container>
                <Breadcrumbs crumb={[t.raw('breadcrumbs.INDUSTRIES'), t.raw('breadcrumbs.DIESEL_GENERATORS')]} />
                <Title title={t('title')} />
                <div className={s.diesel_imageContainer}>
                    <Image src={main} alt={'main'} />
                </div>

                <div className={s.diesel_tasks}>
                    <Title title={t('tasksBlock.title')} />
                    <div className={s.diesel_tasks_container}>
                        {
                            tasksCards.map((item: TTasksCardContent, index: number) => (
                                <TaskCard
                                    key={index}
                                    Icon={item.Icon}
                                    title={item.title}
                                />
                            ))
                        }
                    </div>
                    <div className={s.diesel_tasks_bottomContent}>
                        {
                            t.raw('tasksBlock.text').map((item: string, index: number) => (
                                <ParagraphLine key={index} className={s.diesel_tasks_bottomContent_text}>
                                    { item }
                                </ParagraphLine>
                            ))
                        }
                    </div>
                </div>

                <div className={s.diesel_users}>
                    <Title title={t('usersBlock.title')} />
                    <div className={s.diesel_users_container}>
                        {
                            t.raw('usersBlock.cardsData').map((item: TUserCardContent, index: number) => (
                                <div key={index} className={`${s.diesel_users_card} ${index === 0 ? s.diesel_users_firstCard : ''} ${index === 1 ? s.diesel_users_centralCard : ''} ${index === 2 ? s.diesel_users_lastCard : ''}`}>
                                    <label>{ item.title }</label>
                                    <p>{ item.description }</p>
                                </div>
                            ))
                        }
                    </div>
                </div>

                <div className={s.diesel_monitoring}>
                    <Title title={t('monitoringBlock.title')} />
                    <p className={s.diesel_monitoring_text}>{ t('monitoringBlock.text') }</p>
                    <div className={s.diesel_monitoring_imageContainer}>
                        <Image src={monitoring_equipment} alt={'monitoring_equipment'} />
                    </div>

                    <div className={s.diesel_monitoring_container}>
                        <div className={s.diesel_monitoring_card}>
                            <label>{ t('monitoringBlock.card.title') }</label>

                            <div className={s.diesel_monitoring_card_list}>
                                {
                                    t.raw('monitoringBlock.card.list').map((item: string, index: number) => (
                                        <ul key={index}>
                                            <li className={s.diesel_monitoring_card_item}>
                                                <span><ConfirmIcon/></span>
                                                {item}
                                            </li>
                                        </ul>
                                    ))
                                }
                            </div>
                        </div>

                        <div className={s.diesel_monitoring_textBlock}>
                            {
                                t.raw('monitoringBlock.textBlock').map((item: string, index: number) => (
                                    <React.Fragment key={index}>
                                        {
                                            index === ELEMENT_INDEX.FIRST ?
                                                <ParagraphLine key={index}>{item}</ParagraphLine>
                                                :
                                                <p key={index}>
                                                    {item}
                                                </p>
                                        }
                                    </React.Fragment>
                                ))
                            }
                        </div>
                    </div>
                </div>

                <div className={s.diesel_onlineControl}>
                    <Title title={t('onlineControlBlock.title')} />
                    <div className={s.diesel_onlineControl_container}>
                        <div className={s.diesel_onlineControl_imageContainer}>
                            <Image src={online_control} alt={'online_control'}/>
                        </div>

                        <div className={s.diesel_onlineControl_textBlock}>
                            <label>{ t('onlineControlBlock.textBlock.label') }</label>
                            <ParagraphLine>{ t('onlineControlBlock.textBlock.paragraphLine') }</ParagraphLine>
                        </div>
                    </div>
                </div>

                <div className={s.diesel_parameters}>
                    <Title title={t('parametersBlock.title')}/>

                    <p>{t('parametersBlock.text')}</p>
                </div>

                <div className={s.diesel_generatorSets}>
                    <Title title={t('generatorSetsBlock.title')} />

                    <p className={s.diesel_generatorSets_text}>{ t('generatorSetsBlock.text') }</p>
                    <div className={s.diesel_generatorSets_imageContainer}>
                        <Image src={generator_sets} alt={'generator_sets'} />
                    </div>

                    <div className={s.diesel_generatorSets_textBlock}>
                        {
                            t.raw('generatorSetsBlock.list').map((item: string, index: number) => (
                                <ParagraphLine key={index}>{ item }</ParagraphLine>
                            ))
                        }
                    </div>
                </div>

                <SliderBlock
                    label={t('cases.title')}
                    navigationId={'cases'}
                    data={casesCards}
                    card={(item, index) => (
                        <DieselGeneratorSlideCard
                            key={index}
                            label={item.label}
                            task={(item as TDieselGeneratorSlideCardProps).task}
                            solution={(item as TDieselGeneratorSlideCardProps).solution}
                            image={(item as TDieselGeneratorSlideCardProps).image}
                        />
                    )}
                />

                <ContactUs/>
            </Container>
        </div>
    );
};